import React from 'react';
import Base from './Base';
import { Link } from 'react-router-dom';
import { AuthFooter } from './AuthFooter';

export default class Login extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            mobile: '',
            password: '',
            loading: true,
            passwordFieldType: 'password'
        };
    }

    login(e) {
        e.preventDefault();
        if (this.isBlank(this.state.mobile)) {
            this.showErorrMessage('شماره موبایل را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.password)) {
            this.showErorrMessage('کلمه عبور را وارد نمایید');
            return;
        }
        this.httpPost("api/v1/login/do", {
            mobile: this.state.mobile,
            password: this.state.password
        })
            .then(data => {
                if (data.status === 1) {
                    window.location.href = "/";
                }
                this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد. لطفا مجدد تلاش نمایید.");
            });
    }

    componentDidMount() {
        this.httpPost("api/v1/login/get")
            .then(data => {
                if (data.logged == 1) window.location.href = "/";
                else {
                    this.setState({ data: data, loading: false });
                }
            });
    }

    changePasswordFieldType() {
        if (this.state.passwordFieldType === "password")
            this.setState({ passwordFieldType: "text" });
        else
            this.setState({ passwordFieldType: "password" });
    }

    renderForm() {
        const siteData = this.state.data || {};

        return (
            <div style={{
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem 1rem',
                background: 'radial-gradient(ellipse at 20% 50%, rgba(254,194,20,0.1) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(208,164,32,0.07) 0%, transparent 55%), linear-gradient(135deg, #1B1D24 0%, #2A2A2A 100%)',
                position: 'relative',
                overflow: 'hidden'
            }}>

                {/* دکوراسیون پس‌زمینه */}
                <div style={{
                    position: 'fixed',
                    width: '700px', height: '700px',
                    background: 'radial-gradient(circle, rgba(254,194,20,0.1) 0%, transparent 70%)',
                    top: '-20%', left: '50%',
                    transform: 'translateX(-50%)',
                    filter: 'blur(60px)',
                    pointerEvents: 'none',
                    zIndex: 0
                }} />

                {/* کارت اصلی */}
                <div style={{
                    width: '100%',
                    maxWidth: '920px',
                    position: 'relative',
                    zIndex: 1
                }}>
                    <div style={{
                        background: 'rgba(42,42,42,0.55)',
                        backdropFilter: 'blur(24px)',
                        WebkitBackdropFilter: 'blur(24px)',
                        border: '1px solid rgba(254,194,20,0.22)',
                        borderRadius: '28px',
                        boxShadow: '0 24px 64px rgba(0,0,0,0.55), 0 0 0 1px rgba(254,194,20,0.06) inset',
                        overflow: 'hidden',
                        display: 'flex',
                        minHeight: '520px'
                    }}>

                        {/* ── پنل About (چپ) ── */}
                        <div style={{
                            flex: '0 0 42%',
                            background: 'linear-gradient(145deg, rgba(254,194,20,0.13), rgba(27,29,36,0.9))',
                            borderRight: '1px solid rgba(254,194,20,0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '2.5rem 2rem',
                            textAlign: 'center',
                            color: '#FFFFFF',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            {/* دایره تزئینی */}
                            <div style={{ position: 'absolute', top: '-60px', left: '-60px', width: '220px', height: '220px', borderRadius: '50%', background: 'rgba(254,194,20,0.07)', pointerEvents: 'none' }} />
                            <div style={{ position: 'absolute', bottom: '-40px', right: '-40px', width: '160px', height: '160px', borderRadius: '50%', background: 'rgba(254,194,20,0.05)', pointerEvents: 'none' }} />

                            <div style={{ maxWidth: '300px', position: 'relative', zIndex: 1, width: '100%' }}>
                                <img src="/assets/images/testLogo.png" alt="" style={{ width: "100px", "min-height": "40px" }} />

                                <h2 style={{
                                    fontSize: '2rem', fontWeight: 800, marginBottom: '1rem',
                                    background: 'linear-gradient(135deg, #FEC214, #F8D25F)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text',
                                    lineHeight: 1.3
                                }}>
                                 CRM
                                </h2>
                                <p style={{ color: 'rgba(255,255,255,0.65)', lineHeight: 1.75, marginBottom: '0.75rem', fontSize: '0.88rem' }}>
                                   مدیریت مشتریان
                                </p>
               

                                {/* آمار */}
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                                    <div style={{
                                        textAlign: 'center',
                                        background: 'rgba(254,194,20,0.1)',
                                        border: '1px solid rgba(254,194,20,0.2)',
                                        borderRadius: '14px',
                                        padding: '0.7rem 1.25rem',
                                        minWidth: '90px'
                                    }}>
                                        <span style={{ display: 'block', fontSize: '1.5rem', fontWeight: 800, color: '#FEC214', lineHeight: 1 }}>
                                            تکسیار
                                        </span>
                                        <span style={{ fontSize: '0.76rem', color: '#9D9D9D', marginTop: '0.3rem', display: 'block' }}>
                                          
                                        </span>
                                    </div>
                                </div>

                                {/* اطلاعات تماس */}
                                <div style={{ borderTop: '1px solid rgba(254,194,20,0.15)', paddingTop: '0.75rem', marginTop: '0.5rem' }}>
                                    <div style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.5)', display: 'flex', gap: '0.4rem', justifyContent: 'center', flexWrap: 'wrap', direction: 'rtl', marginBottom: '0.3rem' }}>
                                        <span style={{ color: '#F8D25F' }}>{siteData.support_phone || '06133905574'}</span>
                                        <span style={{ color: '#F8D25F' }}>_{siteData.support_phone || '06133905575'}</span>
                                    </div>
                                    <div style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.5)', display: 'flex', gap: '0.4rem', justifyContent: 'center', direction: 'rtl' }}>
                                        <span style={{ color: '#F8D25F' }}>آدرس : ...</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ── پنل فرم (راست) ── */}
                        <div style={{
                            flex: '1 1 58%',
                            padding: '2.5rem 3rem',
                            direction: 'rtl',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            background: 'rgba(27,29,36,0.4)'
                        }}>
                            <div style={{ marginBottom: '1.75rem' }}>

                                <h4 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#FEC214', marginBottom: '0.25rem' }}>
                                    ورود به سیستم
                                </h4>
                            </div>

                            <form onSubmit={e => this.login(e)}>
                                {/* شماره موبایل */}
                                <div style={{ marginBottom: '1.25rem' }}>
                                    <label style={{ display: 'block', color: '#F8D25F', fontWeight: 500, fontSize: '0.9rem', marginBottom: '0.4rem' }}>
                                        شماره موبایل
                                    </label>
                                    <input
                                        tabIndex="1"
                                        type="text"
                                        defaultValue={this.state.mobile}
                                        onChange={e => this.state.mobile = e.target.value}
                                        placeholder="شماره موبایل"
                                        style={{
                                            width: '100%',
                                            height: '48px',
                                            background: 'rgba(42,42,42,0.85)',
                                            border: '1px solid rgba(254,194,20,0.2)',
                                            borderRadius: '12px',
                                            color: '#FFFFFF',
                                            padding: '0 1rem',
                                            fontSize: '0.95rem',
                                            outline: 'none',
                                            transition: 'all 0.3s ease',
                                            boxSizing: 'border-box',
                                            direction: 'ltr',
                                            textAlign: 'right'
                                        }}
                                        onFocus={e => {
                                            e.target.style.borderColor = 'rgba(254,194,20,0.6)';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(254,194,20,0.12)';
                                        }}
                                        onBlur={e => {
                                            e.target.style.borderColor = 'rgba(254,194,20,0.2)';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>

                                {/* کلمه عبور */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', color: '#F8D25F', fontWeight: 500, fontSize: '0.9rem', marginBottom: '0.4rem' }}>
                                        کلمه عبور
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            tabIndex="2"
                                            type={this.state.passwordFieldType}
                                            defaultValue={this.state.password}
                                            onChange={e => this.state.password = e.target.value}
                                            placeholder="کلمه عبور"
                                            style={{
                                                width: '100%',
                                                height: '48px',
                                                background: 'rgba(42,42,42,0.85)',
                                                border: '1px solid rgba(254,194,20,0.2)',
                                                borderRadius: '12px',
                                                color: '#FFFFFF',
                                                padding: '0 1rem 0 3rem',
                                                fontSize: '0.95rem',
                                                outline: 'none',
                                                transition: 'all 0.3s ease',
                                                boxSizing: 'border-box',
                                                direction: 'ltr',
                                                textAlign: 'right'
                                            }}
                                            onFocus={e => {
                                                e.target.style.borderColor = 'rgba(254,194,20,0.6)';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(254,194,20,0.12)';
                                            }}
                                            onBlur={e => {
                                                e.target.style.borderColor = 'rgba(254,194,20,0.2)';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        />
                                        {/* آیکون چشم */}
                                        <span
                                            onClick={() => this.changePasswordFieldType()}
                                            style={{
                                                position: 'absolute',
                                                left: '14px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                color: '#9D9D9D',
                                                fontSize: '1.1rem',
                                                zIndex: 2,
                                                userSelect: 'none'
                                            }}
                                        >
                                            <em className={`icon ni ${this.state.passwordFieldType === 'password' ? 'ni-eye' : 'ni-eye-off'}`} />
                                        </span>
                                    </div>
                                </div>

                                {/* دکمه ورود */}
                                <button
                                    type="submit"
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                        background: 'linear-gradient(135deg, #FEC214, #D0A420)',
                                        border: 'none',
                                        borderRadius: '14px',
                                        color: '#1B1D24',
                                        fontSize: '1rem',
                                        fontWeight: 700,
                                        letterSpacing: '0.5px',
                                        cursor: 'pointer',
                                        boxShadow: '0 6px 20px rgba(254,194,20,0.35)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={e => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 10px 28px rgba(254,194,20,0.5)';
                                    }}
                                    onMouseLeave={e => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 6px 20px rgba(254,194,20,0.35)';
                                    }}
                                >
                                    ورود
                                </button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? this.renderLoading() : this.renderForm();
        return (
            <div style={{ margin: 0, padding: 0 }}>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {contents}
            </div>
        );
    }
}